// bm-design-system: radio primitive
import * as React from "react";
import { cn } from "@/lib/utils";

export interface RadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="radio"
        className={cn(
          // Catalyst's radio: a round hairline-bordered control that fills with the accent and shows a dot.
          "size-[1.125rem] shrink-0 cursor-pointer appearance-none rounded-full border bg-page shadow-xs",
          "border-[color-mix(in_oklab,var(--color-ink-display)_30%,transparent)]",
          "checked:border-transparent checked:bg-accent checked:bg-[radial-gradient(circle,var(--color-page)_0_28%,transparent_30%)]",
          "dark:border-white/15 dark:bg-white/5 dark:shadow-none dark:checked:border-white/5 dark:checked:bg-accent",
          "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
Radio.displayName = "Radio";

interface RadioGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "vertical" | "horizontal";
}

const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ className, orientation = "vertical", ...props }, ref) => (
    <div
      ref={ref}
      role="radiogroup"
      className={cn(
        "flex gap-3",
        orientation === "vertical" ? "flex-col" : "flex-row flex-wrap",
        className,
      )}
      {...props}
    />
  ),
);
RadioGroup.displayName = "RadioGroup";

export { Radio, RadioGroup };
